export default __webpack_public_path__ + "static/media/investment_card_1@3x.7fd62228.png";